import Alpine from "alpinejs";

const getLanguageLink = (language) => document.querySelector(`link[rel="alternate"][hreflang="${language}"]`)?.href;
const CURRENT_HREF = window.location.pathname;
const CURRENT_LANGUAGE = document.documentElement.lang?.replace("-", "");
const LANGUAGE_LINKS = {
    deAT: getLanguageLink("de-AT"),
    enGB: getLanguageLink("en-GB"),
};
const HAS_MULTIPLE_LANGUAGES = LANGUAGE_LINKS.deAT && LANGUAGE_LINKS.enGB;

Alpine.data("language", function () {
    const BINDINGS = {
        headline: {
            "x-show": () => HAS_MULTIPLE_LANGUAGES,
        },
        links: {
            "x-show": () => HAS_MULTIPLE_LANGUAGES,
        },
    };
    Object.keys(LANGUAGE_LINKS).forEach((language) => {
        const LINK = LANGUAGE_LINKS[language];
        BINDINGS[language] = HAS_MULTIPLE_LANGUAGES
            ? {
                  ":href": () => LINK,
                  ":class": () => CURRENT_LANGUAGE == language && "font-medium",
              }
            : {};
    });
    return BINDINGS;
});

Alpine.data("footerNavigation", () => ({
    link: (url) => ({ ":class": () => (CURRENT_HREF == url ? "text-gray-900" : "text-gray-500") }),
}));

const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

Alpine.data("newsletter", () => ({
    email: "",
    open: false,
    error: false,
    formRendered: false,
    submit: {
        ":disabled"() {
            return !EMAIL_REGEX.test(this.email);
        },
    },
    modal: {
        "x-show"() {
            return this.open;
        },
        "x-lock-scroll"() {
            return this.open;
        },
        "x-trap"() {
            return this.open;
        },
        "x-transition"() {
            return;
        },
    },
    modalContent: {
        "@click.outside"() {
            this.open = false;
        },
    },
    times: {
        "@click"() {
            this.open = false;
        },
    },
    form: {
        "@submit.prevent"() {
            this.open = true;
        },
    },
}));
